<template>
  <v-container mt="4">
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-btn fab elevation="2" class="mb-4" color="primary" @click="showForm = !showForm"
      ><v-icon> {{ showForm ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
    </v-btn>
    <div v-show="showForm">
      <v-form ref="form" v-model="valid" @submit.prevent="handleSubmit">
        <v-card rounded="lg">
          <v-card-title>Add new payment information</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" lg="4">
                <v-menu ref="menu" v-model="menu" :close-on-content-click="true" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="date" label="Payment date" filled v-bind="attrs" v-on="on" :rules="requiredField" />
                  </template>
                  <v-date-picker ref="picker" v-model="date"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field filled label="Source" v-model="source" :rules="requiredField" />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field type="number" v-model="costAmount" filled label="Cost amount" :rules="requiredField" />
              </v-col>
              <v-col cols="12">
                <v-btn type="submit" color="primary" :disabled="!valid" rounded>Add Information</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </div>

    <div class="display-1 text-center mt-10">{{ costDetails.name }}</div>
    <v-row class="mt-2">
      <v-col cols="12">
        <v-card rounded="lg">
          <v-card-text>
            <cost-information-table :tableValue="costDetails.DebitInfo" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <app-snackbar />
  </v-container>
</template>

<script>
import CostInformationTable from '../components/CostInformationTable.vue';
import { mapState } from 'vuex';
import { requiredField } from '../validations/FieldValidation';
import AppSnackbar from '../components/common/AppSnackbar.vue';
import moment from 'moment';

export default {
  components: { CostInformationTable, AppSnackbar },
  data: () => ({
    costAmount: '',
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    source: '',
    menu: false,
    moment,
    requiredField,
    showForm: false,
    valid: true,
  }),

  computed: {
    ...mapState(['costDetails', 'isLoading']),
  },

  created() {
    this.$store.dispatch('getSingleCostInformation', this.$route.params.id);
  },

  methods: {
    handleSubmit() {
      this.$store
        .dispatch('addNewInformationForCost', { _id: this.$route.params.id, date: this.date, through: this.source, paid_tk: parseInt(this.costAmount) || 0 })
        .then(() => this.$refs.form.reset());
    },
  },
};
</script>

<style lang="scss" scoped></style>
